import React from "react";

import LoadingIcon from "react-icons/lib/fa/ellipsis-h";

import { Flex, Text } from "./base";

const Loading = ({ message = "...", color = "muted", m = 3 }) => (
  <Flex m={m} justify="center">
    <Text color={color} align="center" textTransform="uppercase" fontSize={4}>
      <LoadingIcon />
    </Text>
  </Flex>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js